<template>
  <v-app>
    <v-navigation-drawer absolute temporary v-model="navdrawer">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>Folien</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list>
        <v-list-item
          v-for="(page, index) in pages"
          :key="page"
          dense
          @click="setPage(index)"
        >
          <v-list-item-content>
            <v-list-item-title>{{ page }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar app color="primary" dark>
      <v-app-bar-nav-icon
        @click.stop="navdrawer = !navdrawer"
      ></v-app-bar-nav-icon>
      <v-spacer></v-spacer>
    </v-app-bar>

    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import { pagelist } from "@/store/index";
export default {
  name: "App",

  components: {},

  data: () => ({
    navdrawer: Boolean
  }),

  computed: {
    pages: function() {
      return pagelist;
    }
  },

  methods: {
    setPage: function(index) {
      this.$store.commit("setPage", index);
    }
  },

  mounted() {
    this.routeWatcher = this.$watch(
      function() {
        return this.$route;
      },
      function(route) {
        if (route.name !== pagelist[this.$store.state.page]) {
          this.$store.commit("synchronizeStore", route.name);
        }
        this.routeWatcher(); // this disables the watcher
      }
    );
  }
};
</script>
